<div class="product-map-wrapper h-full min-h-0 flex flex-col gap-3" *ngIf="productTreeResource">
  <div class="flex flex-row justify-start gap-3 shrink-0 mt-2">
    <dx-tag-box
      width="50vw"
      [label]="'entity.productFamily.prefix' | translate |ucfirst"
      [value]="selectedProductFamilyPrefixes"
      [dataSource]="productFamilyPrefixes"
      (onValueChanged)="productFamilyPrefixesChanged($event.value)">
    </dx-tag-box>

    <app-product-tag-box
      [(ngModel)]="productIds"
      width="50vw"
      (valueChanged)="productValueChanged($event)">
    </app-product-tag-box>
  </div>

  <div class="product-map-grid-container flex-1 min-h-0 min-w-0">
    <dx-data-grid
      height="100%"
      #gridProductTree
      [allowColumnReordering]="false"
      [remoteOperations]="{ paging: true }"
      [glamResource]="productTreeResource">

      <dxo-selection mode="single"></dxo-selection>

      <dxo-scrolling
        mode="virtual"
        rowRenderingMode="virtual"
        columnRenderingMode="standard">
      </dxo-scrolling>

      <dxo-toolbar>
        <dxi-item location="before">
          <div *dxTemplate>
            <dx-button
              icon="chevrondoubleleft"
              stylingMode="text"
              hint="Primer"
              (onClick)="selectFirstProductCodeMatch()">
            </dx-button>
          </div>
        </dxi-item>

        <dxi-item location="before">
          <div *dxTemplate>
            <dx-button
              icon="chevronleft"
              stylingMode="text"
              hint="Anterior"
              (onClick)="selectPreviousProductCodeMatch()">
            </dx-button>
          </div>
        </dxi-item>

        <dxi-item location="before">
          <div *dxTemplate>
            <dx-button
              icon="chevronright"
              stylingMode="text"
              hint="Següent"
              (onClick)="selectNextProductCodeMatch()">
            </dx-button>
          </div>
        </dxi-item>

        <dxi-item location="before">
          <div *dxTemplate>
            <dx-button
              icon="chevrondoubleright"
              stylingMode="text"
              hint="Últim"
              (onClick)="selectLastProductCodeMatch()">
            </dx-button>
          </div>
        </dxi-item>
      </dxo-toolbar>

      <dxi-column
        width="45"
        cellTemplate="checkboxTemplate"
        [allowSorting]="false"
        [allowFiltering]="false"
        [allowHeaderFiltering]="false">
      </dxi-column>

      <div *dxTemplate="let cell of 'checkboxTemplate'">
        <dx-check-box
          [value]="selectedCheckboxTreeOrder === cell.data.treeOrder"
          (onValueChanged)="toggleProcessSheetSidebarFromCheckbox(cell, $event.value)">
        </dx-check-box>
      </div>

      <dxi-column
        dataField="productCode"
        [caption]="'common.code' | translate | ucfirst"
        cellTemplate="productTemplate">
      </dxi-column>

      <div *dxTemplate="let cell of 'productTemplate'">
        <div class="d-flex align-items-center">
          <span class="tree-depth dx-theme-accent-as-text-color d-flex">
            <span
              *ngFor="let i of [].constructor(cell.data.depth ?? 0)"
              class="me-2"
            >
              ◉
            </span>
          </span>
                <strong>{{ cell.data.productCode }}</strong>
                <span class="hover:underline cursor-pointer ms-2"
                      (click)="openProduct(cell.data)">
            {{ cell.data.productName }}
          </span>
        </div>
      </div>

      <dxi-column
        dataField="processSheetName"
        cellTemplate="processSheetTemplate"
        [caption]="'entity.productionOrder.processSheetId' | translate | ucfirst">
        <div *dxTemplate="let cell of 'processSheetTemplate'">
           <span class="hover:underline cursor-pointer ms-2"
                 (click)="openProcessSheet(cell.data)">
            {{ cell.data.processSheetName }}
          </span>
        </div>
      </dxi-column>

      <dxi-column
        dataField="processSheetVersion"
        [caption]="'entity.processSheet.version' | translate | ucfirst">
      </dxi-column>

      <dxi-column
        dataField="revisionDate"
        dataType="date"
        [caption]="'common.signature' | translate | ucfirst">
      </dxi-column>

      <dxi-column
        dataField="standardCost"
        [format]="{
          type: 'currency',
          precision: (currency?.decimals ? currency?.decimals : 2),
          currency: (currency?.code ? currency?.code : 'EUR')
        }"
        [caption]="'entity.standardCost' | translate | ucfirst">
      </dxi-column>
    </dx-data-grid>
  </div>

  <div
    [class.open]="isProcessSheetSidebarOpen"
    class="product-sheet-sidebar">

    <div class="product-sheet-sidebar-header">

      <div class="flex flex-col gap-2">
        <strong>{{ selectedProductTreeElement?.productCode }}</strong>

        <div>
          {{ selectedProductTreeElement?.productName }}
        </div>

        <dx-check-box
          class="mt-2"
          [text]="'entity.processSheet.showAllVersions' | translate"
          [(value)]="showAllVersions">
        </dx-check-box>
      </div>

      <dx-button
        icon="close"
        stylingMode="text"
        (onClick)="closeProcessSheetSidebar()">
      </dx-button>

    </div>

    <div
      class="product-sheet-card"
      *ngFor="let revision of visibleProcessSheetsRevisions"
      (click)="navigateToProcessSheetEditor(revision)">

      <div class="flex justify-between items-start gap-2">
        <div class="flex flex-col min-w-0">
          <div class="font-bold">
            {{ revision.code }}
          </div>

          <div class="flex items-center gap-2 flex-wrap">
            <span>
              {{ revision.name }}
            </span>

            <span class="text-muted">
              v{{ revision.version }}
            </span>
          </div>

          <div class="text-muted text-sm">
            {{ revision.revisionDate | date:'dd/MM/yyyy' }}
          </div>
        </div>

        <div
          class="process-sheet-state"
          [style.background]="getProcessSheetStateColor(revision.revisionStateId)">

          {{ getProcessSheetStateName(revision.revisionStateId) }}
        </div>
      </div>
    </div>
  </div>
</div>
